import React, { useState } from "react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";  // Import EmailJS SDK
import home from "../pictures/home.jpg";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    eventType: "",
    guests: "",
    questions: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate the form data (you can enhance validation here)
    if (!formData.name || !formData.email || !formData.phone) {
      setStatus("Please fill in all required fields.");
      return;
    }

    // Send the form data to your email using EmailJS
    emailjs
      .send("service_591jogh", "nimantran_x31u5lr", formData, "rIC5PpQPvMA_OMC-J")
      .then(
        (response) => {
          setStatus("Meddelande skickat!");
          setFormData({
            name: "",
            email: "",
            phone: "",
            date: "",
            eventType: "",
            guests: "",
            questions: "",
          });
        },
        (error) => {
          setStatus("Misslyckades att skicka meddelandet. Försök igen.");
        }
      );
  };

  const handleEmailClick = () => {
    const email = "info@nimantran.se";
    window.location.href = `mailto:${email}`;
  };

  return (
    <div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div>
          <img
            alt="home"
            src={home}
            className="md:h-60 h-36 w-auto mt-4 mx-auto rounded-lg shadow-xl shadow-amber-900/40"
          />
        </div>

        <div className="mx-12 my-16">
          <h1 className="text-4xl font-bold text-red-900 drop-shadow-xl">
            Kontakta oss
          </h1>
          <p className="mt-4 text-font text-lg drop-shadow-lg">
            Vi är ett lokalt uthyrningsföretag som är dedikerade till att
            tillhandahålla prisvärd lokalhyra till vårt samhälle.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-12 mx-12">
          <div className="flex-1">
            <h2 className="text-font text-2xl font-semibold drop-shadow-lg">
              Skicka ett meddelande
            </h2>
            <form
              onSubmit={handleSubmit}
              className="flex flex-col gap-2 mt-6 bg-gray-50 p-4 rounded-lg shadow-md"
            >
              {/* Name */}
              <div className="flex items-center gap-2">
                <label className="w-32 text-sm font-medium">Namn:</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="flex-1 p-1 border border-gray-300 rounded text-sm"
                  required
                />
              </div>

              {/* Email */}
              <div className="flex items-center gap-2">
                <label className="w-32 text-sm font-medium">E-Post:</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="flex-1 p-1 border border-gray-300 rounded text-sm"
                  required
                />
              </div>

              {/* Phone */}
              <div className="flex items-center gap-2">
                <label className="w-32 text-sm font-medium">Telefon:</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="flex-1 p-1 border border-gray-300 rounded text-sm"
                  required
                />
              </div>

              {/* Date */}
              <div className="flex items-center gap-2">
                <label className="w-32 text-sm font-medium">Önskat Datum:</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="flex-1 p-1 border border-gray-300 rounded text-sm"
                />
              </div>

              {/* Event Type */}
              <div className="flex items-center gap-2">
                <label className="w-32 text-sm font-medium">Typ av fest:</label>
                <input
                  type="text"
                  name="eventType"
                  value={formData.eventType}
                  onChange={handleChange}
                  className="flex-1 p-1 border border-gray-300 rounded text-sm"
                />
              </div>

              {/* Guests */}
              <div className="flex items-center gap-2">
                <label className="w-32 text-sm font-medium">Antal Personer:</label>
                <input
                  type="number"
                  name="guests"
                  value={formData.guests}
                  onChange={handleChange}
                  className="flex-1 p-1 border border-gray-300 rounded text-sm"
                />
              </div>

              {/* Questions */}
              <div className="flex flex-col gap-1">
                <label className="text-sm font-medium">Övriga frågor:</label>
                <textarea
                  name="questions"
                  value={formData.questions}
                  onChange={handleChange}
                  className="w-full p-1 border border-gray-300 rounded text-sm h-20"
                ></textarea>
              </div>

              {/* Submit Button */}
              <div className="flex justify-end mt-2">
                <button
                  type="submit"
                  className="bg-red-900 text-white py-1 px-3 rounded hover:bg-red-700 text-sm"
                >
                  Skicka
                </button>
              </div>
            </form>
            {status && (
              <p className="mt-4 text-font text-lg font-semibold">{status}</p>
            )}
          </div>

          {/* Contact Info */}
          <div className="flex-1">
            <div className="my-8">
              <h2 className="text-font text-2xl font-semibold drop-shadow-lg">
                Vår adress
              </h2>
              <p className="text-font text-lg font-normal drop-shadow-lg">
                Svaneholm 295, 274 91 Skurup, Skåne Län, Sweden
              </p>
            </div>

            <div className="my-8">
              <h2 className="text-font text-2xl font-semibold drop-shadow-lg">
                Email
              </h2>
              <p onClick={handleEmailClick}>
                <span className="text-font text-lg font-medium underline cursor-pointer drop-shadow-lg hover:text-xl transition-all">
                  info@nimantran.se
                </span>
              </p>
            </div>

            <div className="my-8">
              <h2 className="text-font text-2xl font-semibold drop-shadow-lg">
                Telefon
              </h2>
              <p className="text-font text-lg font-normal underline drop-shadow-lg">
                +46 (0) 73-510 85 04
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Contact;
